import ApiService from '../_helper/api.service';
import AdminApiResources from '../../constants/api/resources/wizard';
import { CustomPosInterface } from '@/types/api/wizard/hotels/customPosInterface';

const HotelService = {
  getHotels(params: any) {
    return ApiService.get(AdminApiResources.hotels, { params: params });
  },

  getHotelList(params: any) {
    return ApiService.get(AdminApiResources.hotelList, { params: params });
  },

  getHotelDetails(params: any) {
    return ApiService.get(AdminApiResources.hotelDetails, { params: params });
  },

  activateGMO(data: any) {
    return ApiService.post(AdminApiResources.paymentSystemGMO, data);
  },
  activateJTB(data: any) {
    return ApiService.post(AdminApiResources.paymentSystemJTB, data);
  },
  activateStripe(data: any) {
    return ApiService.post(AdminApiResources.paymentSystemStripe, data);
  },
  activatePoA(data: any) {
    return ApiService.put(AdminApiResources.activatePoA, data);
  },
  publishHotel(data: any) {
    return ApiService.put(AdminApiResources.publishHotel, data);
  },
  unpublishHotel(data: any) {
    return ApiService.put(AdminApiResources.unpublishHotel, data);
  },
  startHotelAri(data: any) {
    return ApiService.put(AdminApiResources.startHotelAri, data);
  },
  stopHotelAri(data: any) {
    return ApiService.put(AdminApiResources.stopHotelAri, data);
  },
  customPos(data: CustomPosInterface) {
    return ApiService.put(AdminApiResources.customPos, data);
  },
};

export default HotelService;
